import type { IWorkplaceConfigResume } from "../typings"

export const getResumeStepFromWorkplaceConfig = (
  workplaceConfig?: Record<string, unknown> | null
): number => {
  if (!workplaceConfig) return 0

  const wc = workplaceConfig as IWorkplaceConfigResume

  // Step meaning:
  // 0: workplace selection
  // 1: duty locations
  // 2: shift plans
  // 3: summary & publish
  if (!wc.workplaceSelected) return 0
  if (!wc.dutyLocationSelected) return 1

  const shiftRequirementsMet =
    wc.shiftPlanConfigured &&
    wc.shiftPermissionsConfigured &&
    wc.shiftPeriodConfigured &&
    wc.shiftEmployeesConfigured &&
    wc.shiftPlansConfirmed

  return shiftRequirementsMet ? 3 : 2
}

